// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "textarea[data-v-0824a0a9]{word-break:break-all;font-family:monospace;min-height:200px}", ""]);
// Exports
module.exports = exports;
